<script setup>
import { useMetaStore } from '@/stores'
import { ref } from 'vue'

const props=defineProps(['ttl','cont','minWidth']),emit=defineEmits(['cancel','confirm','disabled'])
const cont=ref(null),metaStore=useMetaStore(),minWidth=ref(340)
,disabled=()=>{
  try{
    return emit('disabled')
  }catch(e){
    return false
  }
}
cont.value=props.cont
if(props.minWidth)minWidth.value=parseInt(props.minWidth)
if(cont.value=='save')cont.value=metaStore.t('save_con')
if(cont.value=='mod')cont.value=metaStore.t('mod_con')
else if(!props.cont||cont.value=='del'||cont.value=='delete')cont.value=metaStore.t('del_con')
</script>
<template>
  <v-card class="mx-auto" :min-width="minWidth" :title="props.ttl">
    <v-divider/>
    <v-card-text>
      <div v-html="cont"/>
      <slot v-if="!cont" name="cont"/>
    </v-card-text>
    <v-divider/>
    <v-card-actions>
      <v-row justify="end">
        <v-btn :text="$t('cancel')" variant="outlined" @click.stop="emit('cancel')"/>
        <v-btn :text="$t('confirm')" class="ms-2 me-3" variant="elevated" color="primary" @click.stop="emit('confirm')" :disabled="disabled()"/>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
